export class ChangeMiddleLang {
  static change({ middleLang, IOId, BPId }) {
    return middleLang.map(IO => {
      if (IO.IOId !== IOId) {
        return IO
      }

      IO.BPIds = IO.BPIds.map(BP => {
        if (BP.BPId !== BPId) {
          BP.selected = false
          return BP
        }

        BP.selected = true
        return BP
      })

      return IO
    })
  }
}

export const changeMiddleLang = ({ middleLang, IOId, BPId }) => {
  return ChangeMiddleLang.change({ middleLang, IOId, BPId })
}
